export const getters = {
  systemShippings: state => state.shippings,
  Shipping: state => state.systemShipping,
  systemShippingfiles: state => state.shippingfiles,
  Shippingfile: state => state.systemShippingfile
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/shippings/getters.js